import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::index
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:19
* @route '/admin-panel/contact-groups'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/contact-groups',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::index
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:19
* @route '/admin-panel/contact-groups'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::index
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:19
* @route '/admin-panel/contact-groups'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::index
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:19
* @route '/admin-panel/contact-groups'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::index
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:19
* @route '/admin-panel/contact-groups'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::index
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:19
* @route '/admin-panel/contact-groups'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::index
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:19
* @route '/admin-panel/contact-groups'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:42
* @route '/admin-panel/contact-groups/{group}'
*/
export const destroy = (args: { group: string | { id: string } } | [group: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin-panel/contact-groups/{group}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:42
* @route '/admin-panel/contact-groups/{group}'
*/
destroy.url = (args: { group: string | { id: string } } | [group: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { group: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { group: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            group: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        group: typeof args.group === 'object'
        ? args.group.id
        : args.group,
    }

    return destroy.definition.url
            .replace('{group}', parsedArgs.group.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:42
* @route '/admin-panel/contact-groups/{group}'
*/
destroy.delete = (args: { group: string | { id: string } } | [group: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:42
* @route '/admin-panel/contact-groups/{group}'
*/
const destroyForm = (args: { group: string | { id: string } } | [group: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AdminPanel\ContactGroupsController::destroy
* @see app/Http/Controllers/AdminPanel/ContactGroupsController.php:42
* @route '/admin-panel/contact-groups/{group}'
*/
destroyForm.delete = (args: { group: string | { id: string } } | [group: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const contactGroups = {
    index: Object.assign(index, index),
    destroy: Object.assign(destroy, destroy),
}

export default contactGroups